import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface SeoHeaderWrapper {
    innerHtml: string
}

export const SeoHeaderWrapper = ({innerHtml}: SeoHeaderWrapper) => (
    <div
        dangerouslySetInnerHTML={{
            __html: innerHtml,
        }}
        id="plp-seo-heading"
        className="esi-header-wrapper"
    />
)

export interface SeoHeadingProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children?: JSX.Element
    siteUrl: string
    url: string
    useDevEsi: boolean
    totalResults: number
    title: string
}

const SeoHeading = memo<SeoHeadingProps>(function SeoHeadingMemo({templating, ...props}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName {...props} />
})
SeoHeading.displayName = "SeoHeading"

export default connect(SeoHeading)
